import React, { useCallback, useState } from 'react';
import { DialogContent } from '@material-ui/core';
import { without } from 'lodash';

import { useBrandVoicesAssets } from 'src/store';
import { pluralize } from 'src/utils/format';
import { CustomDialog } from 'src/components/CustomDialog';
import { Checkbox } from 'src/components/Checkbox';
import { ButtonText } from 'src/components/ButtonText';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import CustomFormControlLabel from 'src/components/CustomFormControlLabel';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const BrandRuleSetsPopup = ({ open, onClose, brandVoiceIdsForBrandTerms }) => {
  const styles = useStyles();

  const [brandVoiceIds, setBrandVoiceIds] = useState(brandVoiceIdsForBrandTerms);

  const { brandVoicesAssets } = useBrandVoicesAssets();

  const { handleSubmit, handleRulesSetClick } = useHandlers({
    onClose,
    brandVoiceIds,
  });

  const handleToggleBrandVoice = useCallback(
    (brandVoice) => {
      const newList = brandVoiceIds.includes(brandVoice.id)
        ? without(brandVoiceIds, brandVoice.id)
        : [...brandVoiceIds, brandVoice.id];

      setBrandVoiceIds(newList);
    },
    [brandVoiceIds]
  );

  return (
    <CustomDialog
      className={styles.root}
      onClose={onClose}
      data-testid="BrandRuleSetsPopup"
      title="Enforce brand rules"
      onSubmit={handleSubmit}
      onCancel={onClose}
      submitLabel="Apply"
      cancelLabel="Cancel"
      open={open}
      fullWidth
      classes={{
        root: styles.root,
        dialogTitle: styles.dialogTitle,
        dialogActions: styles.dialogActions,
        buttonCancel: styles.buttonCancel,
        buttonSubmit: styles.buttonSubmit,
        scrollable: styles.scrollable,
      }}
    >
      <DialogContent className={styles.dialogContent}>
        <div className={styles.body}>
          {brandVoicesAssets.map((brandVoice) => {
            const enabledBrandVoiceTermsLength = brandVoice.brandTerms.filter(
              (term) => term.enabled
            ).length;
            return (
              <CustomFormControlLabel
                classes={{ label: styles.label }}
                key={brandVoice.id}
                className={styles.brandVoiceRow}
                control={
                  <Checkbox
                    color="primary"
                    className={styles.checkbox}
                  />
                }
                label={
                  <>
                    <CustomTypography
                      className={styles.brandVoiceName}
                      variant={TYPOGRAPHY_VARIANT.regular14}
                    >
                      {brandVoice.name}
                    </CustomTypography>

                    <ButtonText
                      className={styles.brandVoiceRulesLength}
                      color="primary"
                      onClick={() => {
                        handleRulesSetClick(brandVoice);
                      }}
                    >
                      {enabledBrandVoiceTermsLength}{' '}
                      {pluralize(enabledBrandVoiceTermsLength, 'rule', 'rules')}
                    </ButtonText>
                  </>
                }
                checked={brandVoiceIds.includes(brandVoice.id)}
                onChange={() => handleToggleBrandVoice(brandVoice)}
              />
            );
          })}
        </div>
      </DialogContent>
    </CustomDialog>
  );
};
